import gql from 'graphql-tag';

const CONFIRM_INVESTMENT_INTENT = gql`
    mutation confirmInvestmentIntent(
        $investmentIntentId: String!
        $trxHash: String
    ) {
        confirmInvestmentIntent(
            confirmInvestmentInput: {
                investmentIntentId: $investmentIntentId
                trxHash: $trxHash
            }
        ) {
            id
            walletAddress
            networkId
            userId
            poolId
            amount
            isMigrated
            trxHash
        }
    }
`

export default CONFIRM_INVESTMENT_INTENT;